// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deposit-widget[data-v-811e86d2] {\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n@media (min-width: 768px) {\n  .deposit-widget[data-v-811e86d2] {\n    max-width: 343px;\n  }\n}", ""]);
// Exports
module.exports = exports;
